import type { ValueOf } from '@skin-seoul/utils';
import { WoocommercePaymentMethod } from '../woocommerce/woocommerce';

export const PaymentMethod = {
  Stripe: 'stripe',
  Paypal: 'paypal',
} as const satisfies Pick<typeof WoocommercePaymentMethod, 'Stripe' | 'Paypal'>;

export type PaymentMethodValue = ValueOf<typeof PaymentMethod>;
